import { render, staticRenderFns } from "./AddAnnouncement.vue?vue&type=template&id=bbfc4232&scoped=true&"
import script from "./AddAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AddAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./AddAnnouncement.vue?vue&type=style&index=0&id=bbfc4232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc4232",
  null
  
)

export default component.exports